module.exports = __webpack_public_path__ + "static/media/logo_projectsoft.b19fcf02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_projectsoft.png
// module id = 917
// module chunks = 2